import React, { useContext, useState, useEffect } from 'react'
import CustomTableManage from '../Settings/TableSettings/CustomTableManage'
import FullScreenPopup from '../../components/organisms/FullScreenPopup'

const Templates = (props) => {
    const data = props.data
    const toggle = props.function

    const [tableValues, setTableValues] = useState([
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Id',
        },
        {
            field: 'phrases',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Phrases',
        },
        {
            field: 'reference',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Reference',
        },
    ])
    const filters = {
        id: {
            value: data.id,
            type: 'in',
            field: 'tph.template_id',
        },
        active: {
            value: 1,
            type: 'in',
            field: 'tph.active',
        },
    }
    let customInitial = {
        id: 0,
        template_id: data.id,
    }

    const [fieldValue, setFieldValue] = useState([
        {
            label: 'Pharses',
            placeholder: 'Enter Phrases',
            class: 'col-12 mb-4',
            type: 'text',
            shrink: true,
            name: 'phrases',
            is_required: true,
        },
        {
            label: 'Reference',
            placeholder: 'Enter reference',
            class: 'col-12 mb-4',
            type: 'text',
            shrink: true,
            name: 'reference',
            is_required: true,
        },
        {
            label: 'Type',
            placeholder: 'Enter type',
            class: 'col-12 mb-4',
            type: 'select',
            options: [
                { value: 'date', show: 'Date' },
                { value: 'text', show: 'Text' },
                { value: 'currency', show: 'Currency' },
                { value: 'datetime', show: 'Date Time' },
                { value: 'time', show: 'Time' },
                { value: 'trim', show: 'Trim Character' },
            ],
            name: 'type',
            is_required: true,
        },
    ])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'view' ? 'Template Phrases' : `EDIT TEMPLATE`
            }
            open={data.status === 'view' ? data.popup : false}
            handleClose={() => toggle(false)}
        >
            <CustomTableManage
                primaryTable="template_phrases"
                tableHeading="Template Phrases"
                arrayValue={fieldValue}
                tableValues={tableValues}
                initialLimit={20}
                tableActionString={['delete']}
                tooltipTitle="Edit Phrases"
                filters={filters}
                editButton={true}
                orderBy={'tph.id, desc'}
                customInitial={customInitial}
                secondaryClickID="template_id"
                // tableJoins={[
                //     {
                //         baseTable: 'users',
                //         customTable: 'custom_users',
                //         joinType: 'inner',
                //         baseJoinField: 'id',
                //         connectJoinField: 'user_id',
                //     },
                // ]}
            ></CustomTableManage>
        </FullScreenPopup>
    )
}

export default Templates
